import produce from 'immer'
import {
  FETCH_AUTHENTICATED_USER_SUCCESS,
  INIT_REQUEST,
  LOGOUT_SUCCESS,
  SESSION_EXPIRED,
  SET_LOGIN_ERROR,
  SET_SIDEBAR_STATE,
  SET_TOKEN,
} from './actionTypes'
import { getItem } from '../../utils/localStorage'

export const initialState = {
  user: null,
  initCompleted: false,
  loginError: null,
  sidebarState: 'show',
  token: getItem('token') || null,
}

/* eslint-disable default-case */
const appReducer = (
  state = initialState,
  action: { type: any; user: null; initCompleted: boolean; error: null; data: string; token: any },
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_AUTHENTICATED_USER_SUCCESS:
        draft.user = action.user
        break
      case INIT_REQUEST:
        draft.initCompleted = action.initCompleted
        break
      case LOGOUT_SUCCESS:
        draft.user = null
        break
      case SESSION_EXPIRED:
        draft.user = null
        break
      case SET_LOGIN_ERROR:
        draft.loginError = action.error
        break
      case SET_SIDEBAR_STATE:
        draft.sidebarState = action.data
        break
      case SET_TOKEN:
        draft.token = action.token
        break
    }
  })

export default appReducer
